import { gql } from "@urql/core";

export const MINUTE_TEMPLATE_LIST_QUERY = gql`
  query MinuteTemplateList(
    $filter: JSONObject
    $sorting: [SortInput!]
    $paging: PaginationInput
  ) {
    minuteTemplates(query: { filter: $filter, sorting: $sorting, paging: $paging }) {
      nodes {
        id
        name
        minuteType
        contentType
        version
        venue
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const MINUTE_TEMPLATE_ONE_QUERY = gql`
  query MinuteTemplateOne($id: ID!) {
    minuteTemplate(id: $id) {
      id
      name
      minuteType
      contentType
      version
      content
      documentTemplateId
      documentTemplate {
        id
        documentName
        category
        tag
        templateId
        fileId
        url
        isActive
        createdAt
        updatedAt
      }
      venue
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_MINUTE_TEMPLATE_MUTATION = gql`
  mutation CreateMinuteTemplate($input: CreateMinuteTemplateInput!) {
    createMinuteTemplate(input: $input) {
      id
      name
      minuteType
      contentType
      version
      content
      documentTemplateId
      venue
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MINUTE_TEMPLATE_MUTATION = gql`
  mutation UpdateMinuteTemplate($id: ID!, $input: UpdateMinuteTemplateInput!) {
    updateMinuteTemplate(id: $id, input: $input) {
      id
      name
      minuteType
      contentType
      version
      content
      documentTemplateId
      venue
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_MINUTE_TEMPLATE_MUTATION = gql`
  mutation DeleteMinuteTemplate($id: ID!) {
    deleteMinuteTemplate(id: $id) {
      id
    }
  }
`;
